import { FC } from "react";

import Button from "components/Button";

import styles from "../styles.module.scss";

type PropTypes = {
  onClose?: () => void;
  onConfirm?: () => void;
  isLoading?: boolean;
};

const ModalRemoveReportContent: FC<PropTypes> = ({ onClose, onConfirm, isLoading }) => (
  <div className={styles.content}>
    <p className={styles.description}>
      Are you sure you want to delete this report? This action cannot be undone. But you can generate the report again
      at any time.
    </p>

    <div className={styles.buttons}>
      <Button variant="secondary" onClick={onClose} disabled={isLoading}>
        Cancel
      </Button>

      <Button variant="primary" onClick={onConfirm}>
        Delete
      </Button>
    </div>
  </div>
);

export default ModalRemoveReportContent;
